import { render } from "./gameUi.vue?vue&type=template&id=4325d576&scoped=true"
import script from "./gameUi.vue?vue&type=script&lang=js"
export * from "./gameUi.vue?vue&type=script&lang=js"

import "./gameUi.vue?vue&type=style&index=0&id=4325d576&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4325d576"]])

export default __exports__